import { call, takeLatest } from "redux-saga/effects";
import { API_URL, SAGA_ACTIONS, sagaFunction } from "../_config";
import { CallApi } from "./api/callApi";

function* listCreditCompanies(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.CREDITS.COMPANIES, action.payload, true);
}

function* getCompanyCreditHistory(action: any): any {
  const { companyId, ...params } = action.payload || {};
  const url = API_URL.CREDITS.COMPANY_HISTORY(companyId);
  yield call(sagaFunction, action, CallApi.GET, url, params, true);
}

function* addCredits(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.CREDITS.ADD, action.payload, true);
}

function* deductCredits(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.CREDITS.DEDUCT, action.payload, true);
}

function* listConfigurations(action: any): any {
  yield call(sagaFunction, action, CallApi.GET, API_URL.CREDITS.CONFIGURATIONS, action.payload, true);
}

function* updateConfiguration(action: any): any {
  yield call(sagaFunction, action, CallApi.POST, API_URL.CREDITS.UPDATE_CONFIGURATION, action.payload, true);
}

function* deleteConfiguration(action: any): any {
  const { actionKey, ...rest } = action.payload || {};
  const url = API_URL.CREDITS.DELETE_CONFIGURATION(actionKey);
  yield call(sagaFunction, action, CallApi.DELETE, url, rest, true);
}

function* configurationHistory(action: any): any {
  const { actionKey } = action.payload || {};
  const url = API_URL.CREDITS.CONFIGURATION_HISTORY(actionKey);
  yield call(sagaFunction, action, CallApi.GET, url, {}, true);
}

export default function* adminCreditsSaga() {
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.COMPANIES, listCreditCompanies);
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.COMPANY_HISTORY, getCompanyCreditHistory);
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.ADD, addCredits);
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.DEDUCT, deductCredits);
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.CONFIGURATIONS, listConfigurations);
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.UPDATE_CONFIGURATION, updateConfiguration);
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.DELETE_CONFIGURATION, deleteConfiguration);
  yield takeLatest(SAGA_ACTIONS.ADMIN.CREDITS.CONFIGURATION_HISTORY, configurationHistory);
}
